"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthorizedMiddleware = void 0;
class UnauthorizedMiddleware {
    callback;
    constructor(callback) {
        this.callback = callback;
    }
    async onRequest(request, next) {
        try {
            return await next();
        }
        catch (e) {
            if (e?.response?.status === 401) {
                this.callback();
            }
            return Promise.reject(e);
        }
    }
}
exports.UnauthorizedMiddleware = UnauthorizedMiddleware;
//# sourceMappingURL=unauthorized.middleware.js.map